import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {TranslateService} from '@ngx-translate/core';

import {takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../../destroyable.component';
import {CookieService} from '../../../../shared/cookie-service/cookie.service';
import {EmployeesContextUtilsService} from '../../../../shared/employees/utils/employee-context-utils.service';
import {ModalService} from '../../../../shared/modal';
import {
  POPULATION_CRITERIA_COOKIE_NAME
} from '../../../../shared/population/create-population/create-population.interfaces';
import {PopulationFilterSelector, PopulationFilterTransId, PopulationFilterValue} from '../context-bar.interfaces';

@Component({
  selector: 'gp-context-population',
  templateUrl: './context-population.component.html',
  styleUrls: ['./context-population.component.scss']
})
export class ContextPopulationComponent extends Destroyable implements OnInit {

  private readonly FILTER_LIST_ICON = '<i class="fa-regular fa-filter-list"></i>&nbsp;';

  public populations: PopulationFilterSelector[] = [
    {value: PopulationFilterValue.ALL, transId: PopulationFilterTransId.ALL},
    {value: PopulationFilterValue.CUSTOM, transId: PopulationFilterTransId.CUSTOM}
  ];

  public isCustomPopulation = false;

  private activeRoute: string;
  private selectedPopulation: PopulationFilterSelector;

  constructor(private translate: TranslateService,
              private modalService: ModalService,
              private router: Router,
              private cookieService: CookieService,
              private employeesContextUtilsService: EmployeesContextUtilsService) {
    super();
  }

  ngOnInit() {
    this.employeesContextUtilsService.getContextPopulation().pipe(
      tap(population => {
        this.selectedPopulation = population;
        this.isCustomPopulation = population.value === PopulationFilterValue.CUSTOM;
      }),
      takeUntil(this.componentDestroyed$)
    ).subscribe();
  }

  public onSelect(population: PopulationFilterSelector) {
    if (population.value === PopulationFilterValue.CUSTOM) {
      this.modalService.openModalWithName('CreatePopulation');
    } else {
      this.employeesContextUtilsService.resetSelectedFilters$.next(true);
      this.activeRoute = this.router.url;
      this.employeesContextUtilsService.updateContextPopulation(population);
      if (this.cookieService.getCookie(POPULATION_CRITERIA_COOKIE_NAME)) {
        this.cookieService.deleteCookie(POPULATION_CRITERIA_COOKIE_NAME, '/');
        this.employeesContextUtilsService.refreshPopulation(this.activeRoute);
      }
    }
  }

  public selectedPopulationDisplayValue(): string {
    return (this.isCustomPopulation ? this.FILTER_LIST_ICON : '')
      + this.translate.instant(this.selectedPopulation.transId);
  }
}
